export const getColorBySoftwareName = (name) => {
    if (!name) return '#108ee9';

    const colors = ['#f50', '#2db7f5', '#87d068', '#108ee9'];

    const hash = name
        .split('')
        .reduce((acc, char) => acc + char.charCodeAt(0), 0);

    return colors[hash % colors.length];
};